import { Autocomplete, Grid, Switch, TextField, Tooltip, Typography } from '@mui/material'
import React, { useCallback, useContext, useState } from 'react'
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import dataConnectorStyles from '../../../../../../assets/styles/componentStyles/dataconnector.module.scss'
import AssignVariablesTable from './assignVariableTable';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Required from '../../../../../utility/required';
import GlobalButton from '../../../../../utility/globalButton/button';
import { chatbotDataConnector, configuredWebhookData, customVariableDataInterface, dataConnectorList, functionResponseData } from '../../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { fontColorForMethod, generateUUID } from '../../../../../../utils/constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import GlobalTooltip from '../../../../../utility/tooltip/globalTooltip';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import RefreshIcon from '@mui/icons-material/Refresh';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../../../../context/dataConnectorContext';
import { useWebhookStore } from '../../../../../../store/webhookStore';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { getVariableTypeValue } from '../../../flowBuilderConstants';
import dayjs from 'dayjs';
import IconsColor from '../../../../../utility/iconsColor';
import { primaryColor } from '../../../../../../utils/colors';

interface dataConnectorListProps {
    // dataConnectorList: dataConnectorList[],
    // setDataConnectorList: React.Dispatch<React.SetStateAction<dataConnectorList[]>>,
    // dataConnectorDetails: chatbotDataConnector[],
    // setDataConnectorDetails: React.Dispatch<React.SetStateAction<chatbotDataConnector[]>>,
    payload: any,
    setPayload: React.Dispatch<React.SetStateAction<any>>,
    // getChatbotDataConnectorDetailCall: (connector_id: number, flagUpdatePayloadFromActionData: boolean, flagUpdtePayload: boolean) => void,
    flagShowResponseData: boolean,
    setFlagShowResponseData: React.Dispatch<React.SetStateAction<boolean>>,
    getOrganizationConfiguredWebhooks: any, 
    extractJsonPaths: (data: any) => {
        path: string;
        key: string;
        value: any;
        insideArray: boolean;
    }[], 
    stepAction: any,
}



const WebhookConfig: React.FC<dataConnectorListProps> = (props) => {

    const { payload, setPayload, getOrganizationConfiguredWebhooks, flagShowResponseData, setFlagShowResponseData, extractJsonPaths, stepAction } = props;
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    // const { getChatbotDataConnectorList } = useContext(DataConnectorContext) as DataConnectorContextpayload;
    const configuredWebhookData = useWebhookStore((state) => state.configuredWebhookData);
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const { variableTypes, nodes } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    // const getChatbotDataConnectorListApiCall = async () => {
    //     setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
    //     const res = await getChatbotDataConnectorList();
    //     if (res.status && res.data) {
    //         setDataConnectorList(res.data);
    //     } else {
    //         handleError(res);
    //     }
    //     setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    // }
    const onChangeOfFieldVariableType = useCallback((value: any, ind: number, keyName: string) => {
        setPayload((prevState: any) => ({
            ...prevState,

            [keyName]: prevState[keyName]?.map((para: any, index: any) => {
                if (ind == index) {
                    return {
                        ...para,
                        variable_type: value, 
                        ...(value ? 
                            value?.variable_type_name?.toLowerCase() == "custom" ? 
                                {
                                    metadata_type: null, 
                                    metadata_type_id: null, 
                                }
                                : 
                                {
                                    chatbot_custom_variable_configuration_id: null,
                                }
                            :
                            {
                                metadata_type: null, 
                                metadata_type_id: null, 
                                chatbot_custom_variable_configuration_id: null, 
                                fallback_value: "", 
                                action_await_webhook_identifier_variable_fallback_value: "",
                            }
                        ), 
                    }
                }
                return para;
            })
        }))
    }, [])
    const onChangeOfField = useCallback((value: any | null, ind: number, keyName: string) => {
        if (value?.chatbot_custom_variable_configuration_id == "-1" && value?.chatbot_custom_variable_name == "New Field") {
            setFlagDataCollectionPopup(true);
        } else { 
            setPayload((prevState: any) => ({
                ...prevState,
                [keyName]: prevState[keyName]?.map((para: any, index: any) => {
                    if (ind == index) {
                        // @ts-ignore
                        if (para?.variable_type && para?.variable_type?.variable_type_name == "Metadata") {
                            return {
                                ...para,
                                metadata_type: value ? value : null, 
                                metadata_type_id: value ? value?.metadata_type_id : null,
                            }
                        } else {
                            console.log("value & keyname is something like: ", keyName, value);
                            return {
                                ...para,
                                ...(!value ? 
                                        keyName == "action_await_webhook_save_variable" ?
                                        {
                                            fallback_value: "",
                                        } 
                                        : {}
                                    : 
                                    {}
                                ),
                                chatbot_custom_variable_configuration_id: value ? value.chatbot_custom_variable_configuration_id : null, 
                            }
                        }
                    }
                    return para;
                })
            }))
        }
    }, [])

    const onChangeOfFallbackValue = useCallback((value: string, ind: number, keyName: string) => {
        setPayload((prevState: any) => ({
            ...prevState,
            [keyName]: prevState[keyName]?.map((para: any, index: any) => {
                if (ind == index) {
                    return {
                        ...para,
                        // fallback_value: value 
                        ...(keyName == "action_await_webhook_identifier_field_data" ? 
                            {action_await_webhook_identifier_variable_fallback_value: value}
                            : 
                            {fallback_value: value}
                        )
                    }
                }
                return para;
            })
        }))
    }, [])

    const checkDisableTestRequest = () => {
        return payload?.function_parameters?.some((para: any) => {
            return para.function_parameter_fallback_value?.trim()?.length === 0;
        });
    }


    
    function getSelectedWebhookData() {
        return configuredWebhookData?.find((webhookData: configuredWebhookData) => webhookData.webhook_organization_id == payload.webhook_organization_id)
    }

    const disbaleWebhookDropdown = () => {
        const currentNode = nodes?.find((node: any) => node?.id == stepAction?.chatbot_step_id); 
        if(currentNode){
            const currentWebhookAction =  currentNode?.data?.find((data: any) => data?.flag_saved_in_BE && data?.action_type?.action_type_name?.toLowerCase() == "await_webhook"); 
            if(currentWebhookAction){
                return true; 
            }
        } 
        return false;
    }

    return (
        <>
            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.fullHeight}`}>
                <Grid container className={`${globalStyles.fullHeight}`} gap={"15px"} flexWrap={"nowrap"}>
                    <Grid item xs={12} className={`${globalStyles.fullHeight}`} sx={{ overflow: "auto", padding: "5px" }}>
                        <Grid container gap={"15px"}>
                            <Grid item className={globalStyles.fullwidth}>
                                <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                    <Grid item className={styles.createWorkflowLabelStyle}>
                                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                            <Grid item>
                                                <Grid container alignItems={"center"} gap={"10px"}>
                                                    <Grid item>Select Webhook <Required /> </Grid>
                                                    {payload.chatbot_data_connector_id &&
                                                        <Grid item className={`${globalStyles.displayFlexStyle}`}>
                                                            <Tooltip title="View Custom API in detail">
                                                                <VisibilityIcon
                                                                    className={globalStyles.clickable}
                                                                    onClick={() => {
                                                                        window.open(`${window.location.origin}/customAPI/createCustomAPI?connector_id=${payload.chatbot_data_connector_id}`, "_blank")
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Grid item onClick={() => getOrganizationConfiguredWebhooks()}>
                                                <RefreshIcon className={`${globalStyles.primaryColor} ${globalStyles.clickable}`} />
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                    <Grid item>
                                        <Autocomplete
                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || disbaleWebhookDropdown()}
                                            className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                            options={configuredWebhookData ?? []}
                                            getOptionLabel={(option: configuredWebhookData) => option?.webhook_external.webhook_external_company_name
                                            }
                                            value={getSelectedWebhookData() || null}
                                            onChange={(_, value: configuredWebhookData | null) => {
                                                setFlagShowResponseData(false);
                                                if (value) {
                                                    setPayload((prevState: any) => ({
                                                        ...prevState,
                                                        webhook_organization_id: value.webhook_organization_id,
                                                        expiry_timestamp: "",
                                                        action_await_webhook_identifier_field_data: extractJsonPaths(JSON.parse(value.webhook_external.sample_webhook_response_json)).map((fieldData) => (
                                                            {
                                                                ...fieldData,
                                                                action_await_webhook_identifier_field_id: generateUUID(),
                                                                chatbot_custom_variable_configuration_id: null,
                                                                metadata_type_id: null,
                                                                action_await_webhook_identifier_variable_fallback_value: "",
                                                                identifier_field_path: fieldData.path,
                                                                variable_type: null
                                                            }
                                                        )),
                                                        action_await_webhook_save_variable: [],
                                                    }))
                                                } else {
                                                    // setDataConnectorDetails([]);
                                                    setPayload((prevState: any) => ({
                                                        ...prevState,
                                                        webhook_organization_id: null,
                                                        expiry_timestamp: "",
                                                        action_await_webhook_identifier_field_data: [],
                                                        action_await_webhook_save_variable: [],
                                                    }))
                                                }
                                            }}
                                            renderInput={(params) => <TextField {...params} placeholder="Select Webhook" />}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* {dataConnectorDetails.length > 0 && */}
                            {payload.webhook_organization_id &&
                                <>
                                    {/* URL */}
                                    <Grid item className={globalStyles.fullwidth}>
                                        <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                            <Grid item className={styles.createWorkflowLabelStyle}>URL</Grid>
                                            <Grid item>
                                                <TextField
                                                    value={getSelectedWebhookData()?.webhook_organization_full_path}
                                                    placeholder='URL'
                                                    onChange={(e) => { }}
                                                    className={whatsAppCampaignStyles.whatsappCampaignTextField}
                                                    sx={{ width: "100%", minWidth: "200px", backgroundColor: "white" }}
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/* expiry timestamp */}
                                    <Grid item className={globalStyles.fullwidth}>
                                        <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                            <Grid item className={styles.createWorkflowLabelStyle}>Expiry Timestamp <Required /></Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    {/* <DemoItem label={'"minutes" and "seconds"'}> */}
                                                        <TimePicker views={['minutes', 'seconds']} format="mm:ss"
                                                            value={payload.expiry_timestamp
                                                                ? dayjs(`1970-01-01T${payload.expiry_timestamp}`)
                                                                : null
                                                            }
                                                            className={globalStyles.globalTextfieldStyle} 
                                                            minutesStep={1}
                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                            onChange={(value) => {
                                                                if (!value) return;
                                                                    const minutes = value.minute();
                                                                    const seconds = value.second();
                                                                    if (minutes >= 60) return;
                                                                    const formatted = `00:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
                                                                    setPayload((prevState: any) => ({
                                                                        ...prevState,
                                                                        expiry_timestamp: formatted,
                                                                    }));
                                                                }
                                                            }
                                                        />
                                                    {/* </DemoItem> */}
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {payload.action_await_webhook_identifier_field_data?.length > 0 &&
                                        <Grid item className={globalStyles.fullwidth} sx={{ backgroundColor: "#F4F4F4", padding: "0px 10px", borderRadius: "5px" }}>
                                            <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"} marginBlock={"10px"}>
                                                <Grid item>
                                                    <Grid container gap={1} className={globalStyles.displayFlex}>
                                                        <Grid item>
                                                            <Typography className={whatsAppCampaignStyles.assignValuesTitle}>Webhook Identification Conditions<Required /></Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <GlobalTooltip
                                                                title='Note: At least one identifier field must have the variable type "Dynamic" or "Meta-Data".'
                                                                placement='right'
                                                                arrow
                                                            >
                                                                <span className={globalStyles.clickable}>
                                                                    <IconsColor fillColor={primaryColor} iconName="info" height={"14"} width={"14"} />
                                                                </span>
                                                            </GlobalTooltip>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item className={`${globalStyles.fullwidth}`}>
                                                    <AssignVariablesTable
                                                        tableData={payload.action_await_webhook_identifier_field_data}
                                                        payload={payload.action_await_webhook_identifier_field_data}
                                                        setPayload={setPayload}
                                                        onChangeOfField={onChangeOfField}
                                                        fieldKeyName="action_await_webhook_identifier_field_data"
                                                        onChangeOfFallbackValue={onChangeOfFallbackValue}
                                                        onChangeOfFieldVariableType={onChangeOfFieldVariableType}
                                                        flagVariableAssignment={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }

                                    {
                                        // (dataConnectorDetails[0]?.data_connector_functions?.data_connector_function_response?.function_response_data?.length > 0) &&
                                        <Grid container className={`${globalStyles.flexColumn}`}>
                                            <Grid item>
                                                <Grid container gap={"10px"} className={`${globalStyles.alignItemCenter} ${globalStyles.marginBottom5}`}>
                                                    <Grid item className={styles.createWorkflowLabelStyle}>
                                                        Save Response in Variable
                                                    </Grid>
                                                    <Grid item>
                                                        <Switch
                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                            {...label} checked={flagShowResponseData} onChange={(e) => {
                                                                setFlagShowResponseData(e.target.checked)
                                                                setPayload((prevState: any) => ({
                                                                    ...prevState,
                                                                    action_await_webhook_save_variable: e.target.checked ? extractJsonPaths(JSON.parse(getSelectedWebhookData()?.webhook_external.sample_webhook_response_json || "")).map((res: any) => {
                                                                        return {
                                                                            key: res.key,
                                                                            action_await_webhook_save_variable_id: generateUUID(),
                                                                            chatbot_custom_variable_configuration_id: null,
                                                                            fallback_value: "",
                                                                            path: res.path,
                                                                            field_value_path: res.path, 
                                                                            insideArray: res?.insideArray,
                                                                        }
                                                                    }) : [],
                                                                }))
                                                            }} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {flagShowResponseData &&
                                                <Grid item className={globalStyles.fullwidth} sx={{ backgroundColor: "#F4F4F4", padding: "0px 10px", borderRadius: "5px" }}>
                                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"} marginBlock={"10px"}>
                                                        <Grid item>
                                                            <Typography className={whatsAppCampaignStyles.assignValuesTitle}>Save Variable<Required /></Typography>
                                                        </Grid>
                                                        <Grid item className={`${globalStyles.fullwidth}`}>
                                                            <AssignVariablesTable
                                                                tableData={payload.action_await_webhook_save_variable}
                                                                payload={payload.action_await_webhook_save_variable}
                                                                setPayload={setPayload}
                                                                onChangeOfField={onChangeOfField}
                                                                fieldKeyName="action_await_webhook_save_variable"
                                                                onChangeOfFallbackValue={onChangeOfFallbackValue}
                                                                onChangeOfFieldVariableType={onChangeOfFieldVariableType}
                                                                flagVariableAssignment={false}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            }
                                        </Grid>
                                    }

                                </>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default WebhookConfig
